import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Elementui from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/global.less'
// import './assets/css/lessvariable.less'
// window.sessionStorage.setItem('token', 'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2lkIjoxLCJ1c2VyX2tleSI6ImI0Nzc4MjI3LWZlMGQtNGE1ZS1iYmI2LTNmOTRiMzA3MjRhMCIsInVzZXJuYW1lIjoiYWRtaW4ifQ.5VhuWxPeDroWq7jU2VXAStI74Vbeb3BDORvLfEPme5SpWQnoGJ6IRLmnR4qJoflD8xuFNFIPMeFSEYb4q6N-Uw')
Vue.use(Elementui);
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
